const addCurrencyMask = (e) => {
  let value = e.target.value;
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d)(\d{2})$/, "$1,$2");
  value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
  e.target.value = value;
  return e;
};

const parseAmount = (amount) => {
  if (amount) {
    amount = amount.replace(/\./g, "");
    amount = amount.replace(/,/g, ".");
    return parseFloat(amount);
  }

  return 0;
};

const buildSearchQuery = (data) => {
  let q = "";
  for (let [key, value] of Object.entries(data)) {
    if (value.trim()) {
      q = q + key + "=" + value.trim() + "&";
    }
  }
  return q; // + "page=0&size=20";
};

const setPaging = (pageInfo) => {
  return `page=${pageInfo.page - 1}&size=${pageInfo.pageSize}`;
};

const formatTime = (time) => {
  if (time) {
    const parts = time.split(":");
    return parts[0].padStart(2, "0") + ":" + parts[1].padStart(2, "0");
  }
  return null;
};

export {
  buildSearchQuery,
  setPaging,
  formatTime,
  addCurrencyMask,
  parseAmount,
};
